import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
	Button,
	Col,
	Container,
	Form,
	Modal,
	ModalBody,
	ModalFooter,
	ModalHeader,
	Progress,
	Row,
	// UncontrolledTooltip,
} from 'reactstrap';
import Dropzone from 'react-dropzone';
import Config from '../Util/config';
import HttpUtil from '../Util/httpUtil';
import { AlertasContext } from '../Providers/Alertas';
import { BlockUiContext } from '../Providers/BlockUi';
import ErroTamanhoArquivo from '../Componente/Modais/ErroTamanhoArquivo';
import ResultadoUpload from '../Componente/Modais/ResultadoUpload';
import { withRouter } from 'react-router-dom';

import './ModalUpload.scss';

export const ModalUploadContext = React.createContext();

//TODO OBTER VALORES DO FLUXO
const token = localStorage.getItem('Token');
const isPro = localStorage.getItem('isPro') === 'true';
const isSimulacao = localStorage.getItem('isSimulacao') === 'true';

class ModalUploadProvider extends Component {
	constructor(props) {
		super(props);

		this.state = {
			backdrop: true,
			status: '',
			indexArquivoUpload: 0,
			qtdeTotal: 0,
			pcentUpload: 0,
			progressEventLoaded: 0,
			progressEventTotal: 0,
			progressEvents: [],
			dropzoneStatus: isPro || isSimulacao ? 'inactive' : 'active',
			isOpen: false,
			qtdePermitida: null,
			exibirErroQtde: false,
			exibirErroArquivo: false,
			mensErroArquivo: '',
			openModal: this.openModal,
			onClosed: null,
			documentosRejeitados: false,
			documentosPendentes: false,
			options: {},
			intTotDocErros: 10, //não esquecer de alterar
			intTotDocSimples: 50,
			intTotGuiasSimples: 50,
			intTotDocMultDocOpcao1: 10,
			intTotGuiasMultDocOpcao1: 10,
			intTotDocMultDocOpcao2: 40,
			intTotGuiasMultDocOpcao2: 3,
			intTotDocMultRecOpcao1: 10,
			intTotGuiasMultRecOpcao1: 10,
			intTotDocMultRecOpcao2: 40,
			intTotGuiasMultRecOpcao2: 1,
		};

		this.ResultadoUpload = React.createRef();
	}

	toggleModal = () => {
		this.setState({ isOpen: !this.state.isOpen });
	};

	openModal = () => {
		this.setState({ isOpen: true });
	};

	closeModal = () => {
		this.setState({ isOpen: false });
		if (typeof this.state.onClosed === 'function') this.state.onClosed();
	};

	handleModalClosed = () => {
		setImmediate(() => {
			this.holdAlerts(false);
		});
	};

	validarHabilitarDZ = () => {
		this.setState({
			exibirErroQtde: false,
			mensErroArquivo: '',
			exibirErroArquivo: false,
		});
		if (isSimulacao) this.setState({ dropzoneStatus: 'inactive' });
		else if (isPro) {
			this.setState({ dropzoneStatus: 'active' });
			// this.onLoading(true);

			// HttpUtil.eco_GET(`${Config.urls.API_URL_BASE}Acesso/QuantidadeArquivosPermitidos/${idUsuario}/${token}`, )
			// 	.then(response => {
			// 		this.onLoading(false);
			// 		this.setState({
			// 			qtdePermitida: response.data,
			// 			dropzoneStatus: response.data > 0 ? 'active' : 'inactive',
			// 			exibirErroQtde: response.data <= 0,
			// 		});
			// 	})
			// 	.catch(() => {
			// 		this.onLoading(false);
			// 		this.holdAlerts(true);
			// 		this.showErrorMessage('Ocorreu um erro');
			// 		console.log('Error');
			// 	});
		}
	};

	iniciarUpload = (pStatus, pIndexArquivoUpload, pQtdeTotal) => {
		this.setState({
			status: pStatus,
			indexArquivoUpload: pIndexArquivoUpload,
			qtdeTotal: pQtdeTotal,
			qtdeResult: 0,
			pcentUpload: 10,
			progressEventLoaded: 0,
			progressEventTotal: 0,
			progressEvents: [],
		});
	};

	addProgressEvent(newProgressEvent) {
		let arrUploads = this.state.progressEvents;
		arrUploads.push(newProgressEvent);
		this.setState({ progressEvents: arrUploads });
	}

	onDrop(acceptedFiles, rejectedFiles) {
		if (rejectedFiles.length > 0) {
			let mensagem = "Existe um arquivo de formato inválido ao enviar: '" + rejectedFiles[0].name + "'";
			let tamanhoArquivo = 0;
			tamanhoArquivo = rejectedFiles[0].size;
			if (rejectedFiles.length > 1) {
				tamanhoArquivo = 0;
				mensagem = 'Existem arquivos de formatos inválidos ao enviar: ';
				for (var i in rejectedFiles) {
					tamanhoArquivo += rejectedFiles[i].size;
					mensagem = mensagem + "'" + rejectedFiles[i].name + "', ";
				}
				mensagem = mensagem.substring(0, mensagem.length - 2);
			}
			if (tamanhoArquivo >= 524288000) {
				this.ModalErroTamanhoArquivo.openModal();
			} else {
				this.holdAlerts(true);
				this.showErrorMessage(mensagem);
			}
			this.setState({
				mensErroArquivo: mensagem,
				dropzoneStatus: 'active',
				exibirErroArquivo: true,
			});

			return false;
		}
		this.setState({
			dropzoneStatus: 'inactive',
			exibirErroQtde: false,
			result: {
				Total: 0,
				TotalEmitidos: 0,
				TotalPendentes: 0,
				TotalRejeitados: 0,
			},
		});

		// if (isPro && acceptedFiles.length > this.state.qtdePermitida) {
		// 	this.setState({
		// 		dropzoneStatus: 'active',
		// 		exibirErroQtde: true,
		// 	});
		// 	return false;
		// }

		this.iniciarUpload('Upload', 1, acceptedFiles.length);

		const configAxios = {
			headers: { 'content-type': 'multipart/form-data' },
			onUploadProgress: progressEvent => {
				this.setState({ pcentUpload: Math.round((progressEvent.loaded * 100) / progressEvent.total) });
			},
		};

		const executarUpload = acceptedFiles =>
			new Promise(() => {
				let formData = new FormData();
				acceptedFiles.forEach(formFile => {
					formData.append('file', formFile);
				});
				formData.append('token', token);
				formData.append('hash', JSON.stringify(acceptedFiles)); //TODO - Pegar hash do form

				var urlApi = Config.urls.API_URL_BASE + 'Documento/PostFormData';

				HttpUtil.eco_POST_CONFIG(urlApi, formData, configAxios)
					.then(response => {
						const { data } = response;
						this.setState({
							pcentUpload: 100,
							options: data,
							dropzoneStatus: 'active',
						});

						if (data.blApenasSimples) {
							this.gerarGuias(data.gnre_simples.id);
						} else {
							setImmediate(() => {
								this.setState({
									status: 'MostrarOpções',
								});
							});
						}
					})
					.catch(() => {
						this.setState({ status: 'Result' });
						this.holdAlerts(true);
						//this.showErrorMessage('Ocorreu um erro ao enviar os arquivos');
						this.showInfoMessage('Arquivos em Processamento');
					});
			});

		executarUpload(acceptedFiles);
	}

	handleDescartarInvalidos = blReload => {
		this.onLoading(true);

		HttpUtil.eco_POST(`${Config.urls.API_URL_BASE}Documento/DescartarInvalidos`)
			.then(response => {
				this.onLoading(false);
				const { data } = response;
				if (!data.error) {
					this.showSuccessMessage('Arquivos inválidos descartados com sucesso.');
					if (blReload) {
						window.location.reload(true);
					}
				} else {
					this.holdAlerts(true);
					this.showErrorMessage('Erro ao descartar arquivos inválidos');
					window.location.reload(true);
				}
			})
			.catch(() => {
				this.onLoading(false);
				this.holdAlerts(true);
				this.showErrorMessage('Erro ao descartar arquivos inválidos');
			});
	};

	closeModalEmissao() {
		this.closeModal(true);
		this.props.history.push(`/pendentes`);
	}

	redirectEmissao() {
		this.setState({ status: '' });

		this.closeModal(true);

		if (this.state.result.Total > 1) {
			this.ResultadoUpload.current.openModal(this.state.result);
		} else {
			if (this.state.result.TotalRejeitados > 0) {
				window.location.href = '/rejeitadas';
			} else if (this.state.result.TotalPendentes > 0) {
				window.location.href = '/pendentes';
			} else {
				window.location.href = '/emitidas';
			}
		}
	}

	renderModalProgress = () => (
		<Modal
			size="lg"
			id="modal-upload"
			className="modal-progress"
			isOpen={this.state.isOpen}
			toggle={() => this.closeModal(false)}
			backdrop="static"
			onClosed={this.handleModalClosed}>
			<ModalBody className="h-100">
				<Container>
					<Row className="justify-content-center">
						<Col xs="auto" className="text-center">
							<i className="ecoico ecoico-enviar-arquivos-disabled" alt="Enviando arquivos" />
							<Progress animated value={this.state.pcentUpload} />
							{this.state.pcentUpload >= 100 ? (
								<span className="noselect processando">Processando...</span>
							) : (
								<span className="noselect enviando">Enviando...</span>
							)}
						</Col>
					</Row>
					<Row className="justify-content-center">
						<Col xs="auto">
							<span>
								Aguarde,
								{this.state.pcentUpload >= 100
									? ' estamos validando seus arquivos...'
									: ' fazendo upload dos seus arquivos...'}
							</span>
						</Col>
					</Row>
				</Container>
			</ModalBody>
			<ModalFooter />
		</Modal>
	);

	//#region Tela de Seleção
	gerarGuias = idOption => {
		this.onLoading(true);

		HttpUtil.eco_POST(`${Config.urls.API_URL_BASE}Documento/GerarGuias/${idOption}`)
			.then(response => {
				this.onLoading(false);
				const { data } = response;
				if (!data.error) {
					this.setState({
						result: data,
						dropzoneStatus: 'active',
						status: 'Finalizado',
					});
					this.showSuccessMessage('Guias GNRE geradas com sucesso.');
				} else {
					this.onLoading(false);
					this.holdAlerts(true);
					this.showInfoMessage('Guias em Processamento.');
					window.location.reload(true);
				}
			})
			.catch(() => {
				this.onLoading(false);
				this.holdAlerts(true);
				this.showInfoMessage('Guias em Processamento');
				window.location.reload(true);
			});
	};

	renderModalOptions = () => {
		const { gnre_multi_documentos, gnre_multi_receitas, gnre_simples, intQndeRejeitados } = this.state.options;

		const intDocsMultiDocs = gnre_multi_documentos.intDocsSimples + gnre_multi_documentos.intDocsMulti;
		const intGuiasMultiDocs = gnre_multi_documentos.intGuiasSimples + gnre_multi_documentos.intGuiasMulti;

		const intDocsMultiRec = gnre_multi_receitas.intDocsSimples + gnre_multi_receitas.intDocsMulti;
		const intGuiasMultiRec = gnre_multi_receitas.intGuiasSimples + gnre_multi_receitas.intGuiasMulti;

		return (
			<Modal size="lg" id="modal-upload" className="modal-options" isOpen={this.state.isOpen} backdrop="static">
				<ModalHeader>
					<div className="title">Como gostaria de prosseguir com seus documentos?</div>
					<div className="sub-title">
						Caso queira poderá escolher um dos tipos de agrupamentos disponíveis.
					</div>
					{intQndeRejeitados > 0 && (
						<div className="excluidos">
							<span>
								Dos documentos enviados, {intQndeRejeitados} foram excluidos por não serem compatíveis
								com o processo GNRE.
							</span>
						</div>
					)}
				</ModalHeader>
				<ModalBody>
					<Container>
						<Row>
							<Col>
								<Button
									block
									outline
									id="simples"
									disabled={!gnre_simples.id}
									onClick={() => this.gerarGuias(gnre_simples.id)}>
									<i />
									GNRE Simples
									<p>
										<span>{gnre_simples.intDocsSimples}</span>
										Documento{gnre_simples.intDocsSimples > 1 && 's'} em{' '}
										{gnre_simples.intGuiasSimples} guia{gnre_simples.intGuiasSimples > 1 && 's'}.
									</p>
								</Button>
							</Col>
							<Col>
								<Button
									block
									outline
									id="multiplos-documentos"
									disabled={!gnre_multi_documentos.id}
									onClick={() => this.gerarGuias(gnre_multi_documentos.id)}>
									<i />
									GNRE Múltiplos <br /> Documentos
									<p>
										<span>{intDocsMultiDocs}</span>
										Documento{intDocsMultiDocs > 1 && 's'} em {intGuiasMultiDocs} guia
										{intGuiasMultiDocs > 1 && 's'}.
									</p>
									{/*<p>
										<span>{gnre_multi_documentos.intDocsMulti}</span>
										Documentos em {gnre_multi_documentos.intGuiasMulti} guias.
										 {gnre_multi_documentos.infoUFs && (
											<>
												<i id="tooltip-info-ufs" className="fas fa-info-circle" />
												<UncontrolledTooltip placement="bottom" target="tooltip-info-ufs">
													Guias: {gnre_multi_documentos.infoUFs}
												</UncontrolledTooltip>
											</>
										)} 
									</p>*/}
								</Button>
							</Col>
							<Col>
								<Button
									block
									outline
									id="multiplas-receitas"
									disabled={!gnre_multi_receitas.id}
									onClick={() => this.gerarGuias(gnre_multi_receitas.id)}>
									<i />
									GNRE Múltiplas <br /> Receitas
									<p>
										<span>{intDocsMultiRec}</span>
										Documento{intDocsMultiRec > 1 && 's'} em {intGuiasMultiRec} guia
										{intGuiasMultiRec > 1 && 's'}.
									</p>
									{/*<p>
										<span>{gnre_multi_receitas.intDocsMulti}</span>
										Documentos em {gnre_multi_receitas.intGuiasMulti} guias.
									</p>*/}
								</Button>
							</Col>
						</Row>
					</Container>
				</ModalBody>
			</Modal>
		);
	};
	//#endregion Tela de Seleção

	renderModalDefault = () => (
		<Modal
			size="lg"
			id="modal-upload"
			className="modal-default"
			isOpen={this.state.isOpen}
			toggle={() => this.closeModal(false)}
			backdrop="static"
			onOpened={this.validarHabilitarDZ}
			onClosed={this.handleModalClosed}>
			{/* <ModalHeader onClick={() => this.closeModal(false)}>
				<i className="fas fa-times" />
			</ModalHeader> */}
			<ModalBody className="h-100">
				{isSimulacao && (
					<div className="mensagem-envio-nao-permitido">
						<div className="alert alert-simulation" role="alert">
							Modo simulação não permite enviar arquivos.
						</div>
					</div>
				)}
				{this.state.exibirErroQtde && (
					<div className="mensagem-envio-nao-permitido">
						<div className="alert alert-simulation" role="alert">
							A quantidade de arquivos enviados excedeu o permitido para o usuário teste.
						</div>
					</div>
				)}
				<Container id="enviarArquivos">
					<Row className="justify-content-center">
						<Col xs="auto" className="text-center">
							<Form>
								<Dropzone
									accept="text/xml, application/zip, application/x-zip-compressed"
									maxSize={524288000}
									multiple
									onDrop={(accepted, rejected) => {
										this.onDrop(accepted, rejected, true, false);
									}}
									disabled={
										this.state.dropzoneStatus === 'inactive' || this.state.status === 'Upload'
											? true
											: false
									}>
									{({ getRootProps, getInputProps, isDragAccept, isDragReject }) => (
										<div
											className={`dropUploadBt
												${isDragAccept ? 'acceptStyle' : ''}
												${isDragReject ? 'rejectStyle' : ''}
												${this.state.dropzoneStatus === 'inactive' || this.state.status === 'Upload' ? 'inactive' : ''}`}
											{...getRootProps()}>
											<img src="/img/ecoicos/ecoico-enviar-arquivos.svg" alt="Enviar arquivos" />
											<input {...getInputProps()} />
										</div>
									)}
								</Dropzone>
							</Form>
						</Col>
					</Row>

					<Row className="justify-content-center">
						<Col xs="auto" className="text-center">
							<div className="mensagem-upload">
								<span>Apenas arquivos XML ou ZIP com vários arquivos</span>
								<small>O limite de envio é de 500 MB</small>
							</div>
						</Col>
					</Row>
				</Container>
			</ModalBody>
			<ModalFooter>
				<Container>
					<Row className="justify-content-around">
						<Col xs="auto">
							<Button size="sm" color="info" block onClick={() => this.closeModalEmissao(false)}>
								Não enviar arquivos
							</Button>
						</Col>
						<Col xs="auto">
							<Button size="sm" color="primary" block onClick={() => this.redirectEmissao()}>
								Ir para os arquivos enviados
							</Button>
						</Col>
					</Row>
				</Container>
			</ModalFooter>
		</Modal>
	);

	renderModal() {
		switch (this.state.status) {
			case 'Upload':
				return this.renderModalProgress();
			case 'MostrarOpções':
				return this.renderModalOptions();
			case 'Finalizado':
				this.redirectEmissao();
				break;
			default:
				return this.renderModalDefault();
		}
	}

	render() {
		return (
			<ModalUploadContext.Provider value={this.state}>
				<ErroTamanhoArquivo
					ref={modal => (this.ModalErroTamanhoArquivo = modal)}
					onClosed={this.handleReload}
				/>
				<AlertasContext.Consumer>
					{alertas => {
						this.showInfoMessage = alertas.info;
						this.showSuccessMessage = alertas.success;
						this.showWarningMessage = alertas.warning;
						this.showErrorMessage = alertas.error;
						this.holdAlerts = alertas.setHoldState;
					}}
				</AlertasContext.Consumer>
				<BlockUiContext.Consumer>
					{blockUi => {
						this.onLoading = blockUi.handleLoading;
					}}
				</BlockUiContext.Consumer>
				<ResultadoUpload ref={this.ResultadoUpload} />
				{this.renderModal()}
				{this.props.children}
			</ModalUploadContext.Provider>
		);
	}
}

ModalUploadProvider.propTypes = {
	children: PropTypes.node.isRequired,
};

export default withRouter(ModalUploadProvider);
